export APIClient from './client'

export AuthenticateMiddleware from './middleware/auth'
export CSRFMiddleware from './middleware/csrf'
export ErrorMiddleware from './middleware/error'
export JSONResultMiddleware from './middleware/json-result'

export FileUploadMiddleware from './middleware/file-upload'
export URLUploadMiddleware from './middleware/url-upload'

export paginate from './decorators/paginate'
export apiStore from './decorators/store'
export { filterable, connectToFilterable } from './decorators/filterable'

export BatchAPI from './batch-api'



// WEBPACK FOOTER //
// ./src/shared/api/index.js